import { Box } from '@material-ui/core';
import React, { FC, useState } from 'react';
import {
  EditButton,
  FormTab,
  Show,
  ShowProps,
  TabbedForm,
  usePermissions,
  useRedirect,
  useShowController,
} from 'react-admin';
import { User } from '../../types/user';
import DocumentTitle from '../common/documentTitle/DocumentTitle';
// import UserGeneralTab from './GeneralTab';
import TicketsTab from './TicketsTab';
import ReplyIcon from '@material-ui/icons/Reply';
import { checkPermission } from '../../helpers/checkPermissions';
import UsersTab from './UsersTab';

const WeeklySubscriptionDrawView: FC<ShowProps> = (props) => {
  const { permissions } = usePermissions();
  const controllerProps = useShowController<User>(props);
  const id = props.id ? props.id : controllerProps.record?._id;
  const redirect = useRedirect();
  const [state, setState] = useState({
    isBlocked: false,
  });

  const changeStatus = () => {
    setState({ ...state, isBlocked: !state.isBlocked });
  };

  const toList = () => {
    redirect('/users');
  };

  return (
    <>
      <DocumentTitle
        core='Prize'
        secondary='Weekly Subscription Draw'
        purpose={`${controllerProps.record?.title}`}
        appointment={`${controllerProps.record?.title}`}
      />
      <Box position='relative'>
        <div className='back-icon'>
          <ReplyIcon onClick={toList} />
        </div>
        <Show
          {...props}
          hasEdit={checkPermission(permissions, 'Fixed Odds', 'Update')}
        >
          <TabbedForm className='user-tabs' toolbar={<CustomToolbar />}>
            <FormTab label='Users'>
              <UsersTab id={id || ''} isShow={true} props={props} />
            </FormTab>
            <FormTab label='Tickets'>
              <TicketsTab id={id || ''} isShow={true} props={props} />
            </FormTab>
          </TabbedForm>
        </Show>
      </Box>
    </>
  );
};

const CustomToolbar = () => {
  return <></>;
};

export default WeeklySubscriptionDrawView;
